// Mocked data for the Sales section. Frontend only; wire backend later.

export type InvoiceStatus = 'overdue' | 'due' | 'paid' | 'draft';

export type Invoice = {
  id: string;
  number: string;
  customer: string;
  amount: number;
  issuedOn: string;
  dueOn: string;
  status: InvoiceStatus;
  daysOverdue?: number;
};

export type Payout = {
  id: string;
  date: string;
  amount: number;
  status: 'pending' | 'in_transit' | 'paid';
  method: 'card' | 'bank' | 'interac';
  invoiceId?: string;
};

export type PaymentLink = {
  id: string;
  label: string;
  amount: number | null;
  type: 'invoice' | 'product' | 'donation';
  active: boolean;
  createdOn: string;
};

export type Product = {
  id: string;
  name: string;
  price: number;
  taxable: boolean;
  category?: string;
};

export type IncomeDataPoint = { month: string; amount: number };

export type VelaBrief = {
  id: string;
  message: string;
  cta: string;
  tone: 'info' | 'warning' | 'urgent';
};

export const INVOICES: Invoice[] = [
  { id: 'inv-1', number: 'INV 0247', customer: 'Mrs Joslien Wannechko', amount: 2437, issuedOn: '2026-09-10', dueOn: '2026-09-24', status: 'overdue', daysOverdue: 17 },
  { id: 'inv-2', number: 'INV 0246', customer: 'Highline Clinic', amount: 1500, issuedOn: '2026-09-15', dueOn: '2026-09-29', status: 'overdue', daysOverdue: 12 },
  { id: 'inv-3', number: 'INV 0245', customer: 'Mrs Joslien Wannechko', amount: 624, issuedOn: '2026-08-01', dueOn: '2026-08-15', status: 'paid' },
  { id: 'inv-4', number: 'INV 0244', customer: 'Draft client', amount: 0, issuedOn: '2026-10-11', dueOn: '2026-10-25', status: 'draft' },
];

export const PAYOUTS: Payout[] = [];
export const PAYMENT_LINKS: PaymentLink[] = [];
export const PRODUCTS: Product[] = [];

export const INCOME_6M: IncomeDataPoint[] = [
  { month: 'May', amount: 2200 },
  { month: 'Jun', amount: 1850 },
  { month: 'Jul', amount: 1680 },
  { month: 'Aug', amount: 2100 },
  { month: 'Sep', amount: 2400 },
  { month: 'Oct', amount: 2600 },
];

export const INCOME_TOTAL_6M = INCOME_6M.reduce((s, p) => s + p.amount, 0);
export const INCOME_PREV_6M_TOTAL = 10140;
export const INCOME_DELTA = INCOME_TOTAL_6M - INCOME_PREV_6M_TOTAL;
export const INCOME_DELTA_PCT = Math.round((INCOME_DELTA / INCOME_PREV_6M_TOTAL) * 1000) / 10;

export const TOP_CUSTOMERS = [
  { name: 'Mrs Joslien Wannechko', amount: 624 },
];

export const OVERVIEW_VELA_BRIEFS: VelaBrief[] = [
  {
    id: 'vb-1',
    message: '2 invoices totaling $3,937 are overdue. One is 17 days late. Want me to draft chase emails?',
    cta: 'Review & send',
    tone: 'warning',
  },
];

export const PAYMENT_LINKS_VELA_BRIEFS: VelaBrief[] = [
  {
    id: 'vb-pl-1',
    message: '3 unpaid invoices over $200 are good candidates for payment links. Want to turn them into links in one click?',
    cta: 'Show me',
    tone: 'info',
  },
];